import posthog from 'posthog-js'
import { hasConsent } from './consent'

const isEnabled = process.env.NODE_ENV !== 'development'

const DIRECT = '$direct'
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign']

// Traffic-source properties for event-level attribution: the UTM params of
// the current URL (only the keys that are actually present) plus the
// referrer. PostHog already captures these as person properties on first
// touch; adding them per event makes attribution reliable per purchase.
export function getTrafficSourceProperties(
  search = window.location.search,
  referrer = document.referrer
) {
  const params = new URLSearchParams(search)
  const properties = {}
  UTM_KEYS.forEach((key) => {
    const value = params.get(key)
    if (value) {
      properties[key] = value
    }
  })
  properties.$referrer = referrer || DIRECT
  properties.$referring_domain = referrer ? referringDomain(referrer) : DIRECT
  return properties
}

function referringDomain(referrer) {
  try {
    return new URL(referrer).hostname
  } catch (e) {
    return DIRECT
  }
}

const analytics = {
  capture(event, properties = {}) {
    if (isEnabled && hasConsent()) {
      posthog.capture(event, properties)
    }
  },
  // $user_id is registered as a super property next to identify(): identify
  // only sets the distinct_id, while the analytics ETL filters on $user_id
  // (and platform, registered at init) on every event incl. autocapture.
  identify(userId) {
    if (isEnabled && hasConsent()) {
      posthog.identify(userId.toString())
      posthog.register({ $user_id: userId.toString() })
    }
  },
  reset() {
    if (isEnabled) {
      posthog.unregister('$user_id')
      posthog.reset()
    }
  }
}

export default analytics
